import React from "react";
import { Breadcrumb } from "../../../../components/Breadcrumb";

export const More = () => {
    document.title = "Ətraflı";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Göstəricilər", value: "/dashboard" },
        { name: "Texniki dəstək", value: "/dashboard/support" },
        { name: "Ətraflı", value: "/dashboard/support/more", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Ətraflı</h2>
                    <p>
                        Operatorlar ilə əlaqə saxlamaq üçün və sistemdə yaranmış çətinliklər ilə bağlı texniki dəstəyə müraciət etmək üçün nəzərdə tutulub.
                        Həmçinin, biznes məsləhətləri üçün fərdi məhləhətçi ilə əlaqə saxlamaq olar.
                    </p>
                    <img src="/images/dashboard/support/more.gif" alt="Ətraflı" />
                </article>
            </div>
        </div>
    );
};
